var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommunication = function SvgCommunication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "communication_svg__a",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#communication_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m8.054 23.336-2.67 2.67q-.568.568-1.308.255-.74-.314-.74-1.12V5.746q0-1.01.7-1.71a2.33 2.33 0 0 1 1.71-.7H26.26q1.01 0 1.71.7t.7 1.71v15.18q0 1.01-.7 1.71t-1.71.7zm1.282-5h8q.424 0 .712-.288a.97.97 0 0 0 .288-.712.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287h-8a.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712q0 .425.287.713.288.287.713.287m0-4h13.333q.425 0 .713-.288a.97.97 0 0 0 .287-.713.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.287H9.336a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .426.287.713.288.287.713.287m0-4h13.333q.425 0 .713-.288a.97.97 0 0 0 .287-.713.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.287H9.336a.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712q0 .426.287.713.288.287.713.287"
  }))));
};
export default SvgCommunication;